import {Navigate, Route} from 'react-router-dom';
import {EnrollLayout} from '@client/pages/public/enroll/EnrollLayout';
import {EnrollLanding} from '@client/pages/public/enroll/pages/EnrollLanding';
import {EnrollAccessCode} from '@client/pages/public/enroll/pages/EnrollAccessCode';
import {EnrollFaq} from '@client/pages/public/enroll/pages/EnrollFaq';
import {EnrollHowToEnroll} from '@client/pages/public/enroll/pages/EnrollHowToEnroll';
import {EnrollResources} from '@client/pages/public/enroll/pages/EnrollResources';
import {EnrollNotices} from '@client/pages/public/enroll/pages/EnrollNotices';
import {EnrollSteps} from '@client/pages/public/enroll/EnrollSteps';
import {ProductStep} from '@client/pages/public/enroll/steps/ProductStep';
import {ProtectionStep} from '@client/pages/public/enroll/steps/ProtectionStep';
import {ReviewStep} from '@client/pages/public/enroll/steps/ReviewStep';
import {CheckoutStep} from '@client/pages/public/enroll/checkout/CheckoutStep';
import {ConfirmationStep} from '@client/pages/public/enroll/confirmation/ConfirmationStep';

/**
 * Route subtree for the public enrollment site, colocated with the feature.
 * Returned as a fragment so it can be dropped into the app's top-level <Routes>.
 */
export function enrollRoutes() {
  return (
    <Route path='/:groupSlug' element={<EnrollLayout />}>
      <Route index element={<EnrollLanding />} />
      <Route path='access-code' element={<EnrollAccessCode />} />
      <Route path='faq' element={<EnrollFaq />} />
      <Route path='how-to-enroll' element={<EnrollHowToEnroll />} />
      <Route path='resources' element={<EnrollResources />} />
      <Route path='notices' element={<EnrollNotices />} />
      <Route element={<EnrollSteps />}>
        <Route path='medical' element={<ProductStep category='medical' />} />
        <Route path='dental' element={<ProductStep category='dental' />} />
        <Route path='vision' element={<ProductStep category='vision' />} />
        <Route path='protection' element={<ProtectionStep />} />
        <Route path='review' element={<ReviewStep />} />
        <Route path='checkout' element={<CheckoutStep />} />
        <Route path='confirmation' element={<ConfirmationStep />} />
      </Route>
      <Route path='*' element={<Navigate to='medical' replace />} />
    </Route>
  );
}
